import { render, staticRenderFns } from "./Commits.vue?vue&type=template&id=1bbf8f0e&"
import script from "./Commits.vue?vue&type=script&lang=js&"
export * from "./Commits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports